import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react'
import { ArticleLayout, FullLayout } from '../components/Article';
import { BeyondArticleTabs, BeyondLandingBackgroundLogo, BeyondLandingCTA, BeyondLandingLogoAndText, BeyondProgress, BeyondTakeaways } from '../components/Beyond'
import { Footer } from '../components/General';
import { Meta } from '../components/Meta';
import { NavBar } from '../components/NavBar';
import { LayoutSerializer } from '../components/Serializers';
import { useStore } from '../lib/context';
import { hexToRgbaString } from '../lib/helpers';
import { UtilityNav } from '../components/UtilityNav'

const BeyondArticle = observer(({data}) => {
    const {
        uiStore: {
          updateArticlePrimaryColor,
          updateArticleSecondaryColor,
          updateArticleUIHoverColor,
          updateArticleTextHighlightColor,
          updateNavBarColor,
          updateNavBarTextColor,
          updateFooterColor,
          updateFooterTextColor,
          scrollTo,
          windowHeight
        },
      } = useStore()
    
      const {
        primaryColor,
        secondaryColor,
        tertiaryColor,
        textHighlightColor,
        uiHoverColor,
        title, 
        description,
        heroImage
      } = data.contentfulBeyondArticleV2
      
    const initializeColors = () => {
        updateNavBarColor(hexToRgbaString(primaryColor))
        updateNavBarTextColor(hexToRgbaString(tertiaryColor))
        updateFooterColor(hexToRgbaString(secondaryColor))
        updateFooterTextColor(hexToRgbaString(textHighlightColor))
        updateArticlePrimaryColor(hexToRgbaString(primaryColor))
        updateArticleSecondaryColor(hexToRgbaString(secondaryColor))
        updateArticleUIHoverColor(uiHoverColor);

        // made a change here this is using the secondary color for now instead of text highlight color!!
        updateArticleTextHighlightColor(hexToRgbaString(tertiaryColor))
      }

      useEffect(() => {
        initializeColors()

        
      }, [])

    return (
        <div>
            <Meta
                title={title}
                description={description}
                image={heroImage}
            />
            {/* <UtilityNav />
            <NavBar/> */}
            <BeyondArticleHead data={data}/>
            {/* <BeyondProgress data={data.contentfulBeyondArticleV2}/> */}
            <div className="beyond-article-content">
                <ArticleLayout>
                    <LayoutSerializer content={data.contentfulBeyondArticleV2.content}/>

                        <FullLayout backgroundColor={primaryColor} hasBackgroundColor={true} noParallax={true}>
                            <BeyondTakeaways takeaways={data.contentfulBeyondArticleV2.takeaways}/>
                            {/* <Footer/> */}
                        </FullLayout>
                </ArticleLayout>
            </div>

            <style jsx>{`
                div {
                    background: black;
                    overflow: hidden;
                }

                .beyond-article-content :global(*) {
                    color: white;
                }

                .beyond-article-content :global(.toggle-modal-button) {
                    display: none;
                }
                
                .beyond-article-content :global(.headline.serif), .beyond-article-content :global(.headline.serif *) {
                    font-family: "elizeth";
                    font-weight: 900;
                    font-style: italic;
                }

                .beyond-article-content :global(.footer *),  .beyond-article-content :global(.beyond-takeaways *){
                    color: black !important;
                }

                @media (max-width: 769px), (pointer: coarse) {
                    div {
                        padding-bottom: 20px;
                    }
                }
            `}</style>
        </div>
    )
});

const BeyondArticleHead = ({data}) => {
    return (
        <div>
            <BeyondLandingBackgroundLogo data={data.contentfulBeyondArticleV2}/>
            <BeyondLandingLogoAndText data={data.contentfulBeyondArticleV2}/>
            <style jsx>{`
                div {
                    height: 100vh;
                    position: relative;
                }
            `}</style>
        </div>
    )
}



export const query = graphql`
  query($slug: String!) {
    contentfulBeyondArticleV2(slug: { eq: $slug }) {
        title
        slug
        authorV2 {
            raw
        }
        headingV2 {
            raw
        }
        primaryColor
        secondaryColor
        tertiaryColor

        heroImage {
            title
            description
            resolutions {
              aspectRatio
            }
            file {
              url
              fileName
              contentType
            }
        }

        content {
            ...FullLayout
            ...HalfCenteredLayout
            ...HalfLayout
        }
        sectionMarkerTitles
        takeaways {
            heading
			statement {
				statement
			}
			numbered
			takeaways {
                title
				headlineContent {
					raw
				}
				copyContent {
					raw
				}
			}
		}

    }
  }
`


export default BeyondArticle